export default __webpack_public_path__ + "static/media/Desenvolvimento-Medida.1220645d.webp";